
export const frequencyDisplay = (frequency) => {
    const data = {
        "MONTHLY": "Monthly",
        "BI_MONTHLY": "Bi-Monthly",
        "BI-MONTHLY": "Bi-Monthly",
        "WEEKLY": "Weekly",
    }
    return data[frequency] ?? frequency;
}